// extracted by mini-css-extract-plugin
module.exports = {"message":"SuccessQRCodePage_message__3EeAg","successPage":"SuccessQRCodePage_successPage__3qDmt"};